function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { Sides } from '../constants';
import getTransition from '../getTransition';
import stopTransitionOnSideChange from '../stopTransitionOnSideChange';
import styled from 'styled-components';
var StyledOverlay = styled.div.attrs({
  style: function style(_ref) {
    var side = _ref.side,
        verticalWipePercentage = _ref.verticalWipePercentage;
    return {
      transform: side === Sides.Right ? "translateX(".concat(verticalWipePercentage, "%)") : "translateX(-".concat(verticalWipePercentage, "%)")
    };
  }
})(_templateObject(), function (props) {
  return props.overlayColor;
}, getTransition);
var Overlay = stopTransitionOnSideChange(StyledOverlay);
export default Overlay;